import { render, staticRenderFns } from "./ApprovalCycleStats.vue?vue&type=template&id=1b609c72&scoped=true"
import script from "./ApprovalCycleStats.vue?vue&type=script&lang=js"
export * from "./ApprovalCycleStats.vue?vue&type=script&lang=js"
import style0 from "./ApprovalCycleStats.vue?vue&type=style&index=0&id=1b609c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b609c72",
  null
  
)

export default component.exports